import { render, staticRenderFns } from "./ceping-record.vue?vue&type=template&id=7162d917&scoped=true"
import script from "./ceping-record.vue?vue&type=script&lang=ts"
export * from "./ceping-record.vue?vue&type=script&lang=ts"
import style0 from "./ceping-record.vue?vue&type=style&index=0&id=7162d917&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7162d917",
  null
  
)

export default component.exports